"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var payment_methods_1 = require("../../common/constants/payment_methods");
var months_and_years_1 = require("../../common/constants/months_and_years");
var months_and_years_2 = require("../../common/constants/months_and_years");
var states_1 = require("../../common/constants/states");
var Order_1 = require("../../classes/Order");
var Coupon_1 = require("../../classes/Coupon");
var Payment_1 = require("../../classes/Payment");
var Student_1 = require("../../classes/Student");
var LineItem_1 = require("../../classes/LineItem");
var dinero_js_1 = __importDefault(require("dinero.js"));
var Teller_1 = require("../../../DriveScout/Billing/Teller");
var PaymentRequest_1 = require("../../common/payments/PaymentRequest");
var StudentOrderController = /** @class */ (function () {
    function StudentOrderController(OrdersModel, FlashService, UsersModel, $stateParams, UserService, CreateOrderService, OrderDetailsService, $location, Stripe3DSService, VueStoreFactory, $scope) {
        var _this = this;
        /** The card payment's key, held across a retry of the same details. */
        this.orderPayment = new PaymentRequest_1.PaymentRequest();
        /** The PayPal approval's key, held from its create until its capture ends. */
        this.paypalApproval = new PaymentRequest_1.PaymentRequest();
        this.loading = true;
        this.$scope = $scope;
        this.VueStoreFactory = VueStoreFactory;
        this.amount_owed = 0;
        this.$stateParams = $stateParams;
        this.months = months_and_years_1.Months;
        this.years = months_and_years_2.Years;
        this.states = states_1.States;
        this.payment = {
            payment_method: "card",
            payment_amount: 0,
            card: {
                use_existing_payment_method: false,
                billing_address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: "",
                },
            },
        };
        this.fee = null;
        this.fees = [];
        this.payment_methods = payment_methods_1.PaymentMethods;
        this.OrdersModel = OrdersModel;
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.OrderDetailsService = OrderDetailsService;
        this.currentUser = UserService.getCurrentUser();
        this.returnUrl = $location.absUrl();
        this.showUseExistingPaymentMethodUI = false;
        this.Stripe3DSService = Stripe3DSService;
        this.handleAuthorizeCard = this.handleAuthorizeCard.bind(this);
        this.handleCompletedConfirmationToken =
            this.handleCompletedConfirmationToken.bind(this);
        this.setStudentCart = this.setStudentCart.bind(this);
        this.buttonText = this.buttonText.bind(this);
        this.tokenizationSupported = this.tokenizationSupported.bind(this);
        this.createPaypalOrder = this.createPaypalOrder.bind(this);
        this.handlePaypalCardTokenCreated =
            this.handlePaypalCardTokenCreated.bind(this);
        this.policies = {
            billing: {
                policymeta: {},
            },
        };
        this.surchargeAmountBilled = 0;
        this.$cashier = CreateOrderService.cashier();
        this.gateway = this.OrderDetailsService.billingConfig.gateway;
        this.gateway_config = this.OrderDetailsService.billingConfig.gateway_config;
        if (this.gateway === "stripe") {
            this.stripeElementOptions = {
                currency: "usd",
                amount: undefined,
            };
        }
        // set surcharge data
        this.surchargeBilledSeparately = this.$cashier.surchargeBilledSeparately();
        this.surchargePercentage = this.$cashier.surchargePercentage();
        this.surchargeDetail = this.$cashier.surchargeDetail();
        this.UsersModel.getStudentPaymentMethods(this.currentUser.id).then(function (response) {
            _this.$cashier.setStudentPaymentMethods(response.payment_methods);
        });
        // Get the order details and load this order into memory if it isn't already
        OrdersModel.getDetails({ id: $stateParams.orderID }).then(function (response) {
            var $order = new Order_1.Order();
            var $payments = response.data.payments.map(function (payment) {
                return new Payment_1.Payment(payment);
            });
            var $lineitems = response.data.order.lineitems.map(function ($lineitem) {
                return new LineItem_1.LineItem($lineitem);
            });
            var $products = $lineitems.map(function ($lineitem) {
                return $lineitem.product();
            });
            var $student = new Student_1.Student(_this.currentUser);
            if (response.data.order.coupons.length > 0) {
                var $coupon = new Coupon_1.Coupon(response.data.order.coupons[0]);
                $order.setCoupon($coupon);
            }
            $order.setNotes(response.data.order.notes);
            $order.setStatus(response.data.order.status);
            $order.setPayments($payments);
            $order.setLineItems($lineitems);
            $order.setStudent($student);
            $order.setPaid(response.data.order.paid);
            $order.$id = response.data.order.id;
            $order.$created_at = response.data.order.created_at;
            $order.setProducts($products);
            $order.setTotal(response.data.order.total);
            $order.financial_summary = response.data.order.financial_summary || null;
            _this.$cashier.setOrder($order);
            _this.calculateAmountOwed($payments);
            _this.loading = false;
        });
    }
    /**
     * Calculate the surcharge in cents for a given value in cents
     */
    StudentOrderController.prototype.calculateSurcharge = function (totalDue) {
        if (this.$cashier.surchargeBilledSeparately() === false) {
            return 0;
        }
        if (this.$cashier.surchargeBilledSeparately()) {
            return (0, dinero_js_1.default)({ amount: totalDue, currency: "USD" })
                .percentage(this.$cashier.surchargePercentage())
                .getAmount();
        }
        return 0;
    };
    StudentOrderController.prototype.selectPaymentMethod = function (paymentMethodID) {
        this.payment.card.payment_method_id = paymentMethodID;
        this.payment.card.use_existing_payment_method = true;
    };
    StudentOrderController.prototype.paymentWithSurcharge = function (amount) {
        return amount + this.calculateSurcharge(amount);
    };
    /**
     * Calculate the total amount billed for the order.
     */
    StudentOrderController.prototype.totalBilled = function () {
        // return with the surcharge amount applied to whatever the payment amount is.
        // the payment amount should be in cents.
        if (this.payment.hasOwnProperty("payment_amount") &&
            this.payment.payment_amount > 0) {
            return this.paymentWithSurcharge(this.payment.payment_amount);
        }
        // if no payment is being made, return 0 cents
        return 0;
    };
    /**
     * Because students can only make payments electronically, if the surcharge setting
     * is on, it always applies to students.
     */
    StudentOrderController.prototype.checkSurchargeRequired = function () {
        return this.surchargeBilledSeparately;
    };
    /**
     * This sets the amount the student owes on the controller instance.
     */
    StudentOrderController.prototype.calculateAmountOwed = function (payments) {
        var summary = this.$cashier.order().financial_summary;
        if (summary) {
            this.amount_owed = summary.collection_closed ? 0 : summary.collection_balance;
            return;
        }
        if (this.$cashier.order().status() === "VOID") {
            this.amount_owed = 0;
        }
        else {
            var amountPaid = 0;
            if (payments.length > 0) {
                amountPaid = payments
                    .filter(function (payment) {
                    return payment.isVoid() === false;
                })
                    .reduce(function (carry, payment) {
                    return carry + payment.amount();
                }, 0);
            }
            this.amount_owed = this.$cashier.order().total() - amountPaid;
        }
    };
    StudentOrderController.prototype.addBillingAddress = function (index, address) {
        if (!this.payment.hasOwnProperty("card")) {
            this.payment.card = {
                billing_address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: "",
                },
            };
        }
        this.payment.card.billing_address = address;
    };
    StudentOrderController.prototype.formatPaymentAmount = function (amount) {
        return (0, Teller_1.inDollars)(amount);
    };
    StudentOrderController.prototype.toggleUseExistingPaymentMethod = function () {
        this.showUseExistingPaymentMethodUI = !this.showUseExistingPaymentMethodUI;
        if (this.showUseExistingPaymentMethodUI === true) {
            delete this.payment.card.payment_method_id;
            this.payment.card.use_existing_payment_method = false;
            if (this.gateway === "stripe") {
                delete this.stripeElementOptions.amount;
            }
        }
    };
    StudentOrderController.prototype.proceedToPayment = function (amount) {
        delete this.payment.card.payment_method_id;
        this.payment.card.use_existing_payment_method = false;
        this.showUseExistingPaymentMethodUI = false;
        if (this.gateway === "stripe") {
            this.stripeElementOptions.amount = amount;
        }
    };
    StudentOrderController.prototype.tokenizationSupported = function () {
        if (this.gateway === "authorize" &&
            this.gateway_config.authorize_api_client_key) {
            return true;
        }
        if (this.gateway === "stripe") {
            return true;
        }
        if (this.gateway === "paypal") {
            return true;
        }
        if (this.gateway === "square") {
            return true;
        }
        return false;
    };
    StudentOrderController.prototype.handleAuthorizeCard = function (tokenData) {
        if (!this.gateway_config.authorize_api_client_key) {
            this.payment.card = tokenData;
        }
        else {
            this.payment.card.token = {
                opaqueData: tokenData,
            };
            delete this.payment.card.name_on_card;
            delete this.payment.card.number;
            delete this.payment.card.expiration_month;
            delete this.payment.card.expiration_year;
            delete this.payment.card.cvc;
        }
        this.submitPayment();
    };
    StudentOrderController.prototype.billingAddressValid = function (address) {
        if (address.street && address.city && address.state && address.zip) {
            return true;
        }
        return false;
    };
    StudentOrderController.prototype.setStudentCart = function () {
        var payload = {
            payment_amount: this.payment.payment_amount,
            payment_method: this.payment.payment_method,
        };
        if (this.payment.card.billing_address) {
            payload.billing_address = {
                street: this.payment.card.billing_address.street,
                city: this.payment.card.billing_address.city,
                state: this.payment.card.billing_address.state,
                zip: this.payment.card.billing_address.zip,
            };
            if (this.billingAddressValid(payload.billing_address) === false) {
                delete payload.billing_address;
            }
        }
        return this.UsersModel.setStudentCart(this.currentUser.id, payload)
            .then(function (response) {
            return response;
        })
            .catch(function (Error) {
            console.error(Error);
        });
    };
    StudentOrderController.prototype.handleCompletedConfirmationToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var cart, billing_address, payment_amount, payment_method;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.UsersModel.getStudentCart(this.currentUser.id)];
                    case 1:
                        cart = (_a.sent()).cart;
                        billing_address = cart.billing_address, payment_amount = cart.payment_amount, payment_method = cart.payment_method;
                        if (billing_address) {
                            this.payment.card.billing_address = billing_address;
                        }
                        this.payment.payment_amount = payment_amount;
                        this.payment.payment_method = payment_method;
                        // set token data on order
                        if (this.payment.payment_method === "card") {
                            if (this.gateway === "stripe" || this.gateway === "square") {
                                this.payment.card.token = token.token;
                                this.payment.card.save_payment_method = token.save_payment_method;
                            }
                            else {
                                this.payment.card.token = token;
                            }
                        }
                        this.submitPayment();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    StudentOrderController.prototype.submitPayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payment, orderId, response, threeDSResult, confirmResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        payment = structuredClone(this.payment);
                        if (this.currentUser.role.type === "student") {
                            payment.payment_method = "card";
                        }
                        orderId = this.$cashier.order().id();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.OrdersModel.submitPayment(this.orderPayment.bodyFor({ order_id: orderId, payment: (0, PaymentRequest_1.withoutOneTimeToken)(payment) }, function (requestId) { return ({
                                order_id: orderId,
                                payment: payment,
                                request_id: requestId,
                            }); }))];
                    case 2:
                        response = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.gateway_config.stripe_publishable_key)];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.challengeFailed(threeDSResult));
                            this.submitted = false;
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmOrderPayment(this.$cashier.order().id(), response.payment_intent_id, {
                                student_id: this.currentUser.id,
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.answered(confirmResponse));
                        this.handlePaymentSuccess(confirmResponse, payment);
                        return [2 /*return*/];
                    case 5:
                        // Standard payment success (no 3DS required)
                        this.handlePaymentSuccess(response, payment);
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        this.submitted = false;
                        this.$scope.$applyAsync();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handle successful payment response
     */
    StudentOrderController.prototype.handlePaymentSuccess = function (response, payment) {
        this.submitted = false;
        this.amount_owed -= payment.payment_amount;
        this.FlashService.setMessage({
            type: "success",
            message: response.message,
        });
        var $payments = __spreadArray(__spreadArray([], this.$cashier.order().payments(), true), [
            new Payment_1.Payment(response.payment),
        ], false);
        this.$cashier.order().setPayments($payments);
        this.$cashier.order().setPaid(response.order.paid);
        this.$cashier.order().setStatus(response.order.status);
        this.$cashier.order().setTotal(response.order.total);
        this.$cashier.order().financial_summary = response.order.financial_summary || null;
        this.$cashier.order().setNotes(response.order.notes);
        this.calculateAmountOwed(this.$cashier.order().payments());
        this.payment = {
            payment_method: "card",
            payment_amount: 0,
            card: {
                billing_address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: "",
                },
            },
        };
        this.$scope.$applyAsync();
    };
    StudentOrderController.prototype.buttonText = function () {
        if (this.payment.payment_amount > 0) {
            return "Submit Payment for ".concat(this.formatPaymentAmount(this.totalBilled()));
        }
        return "Submit";
    };
    StudentOrderController.prototype.createPaypalOrder = function () {
        return __awaiter(this, void 0, void 0, function () {
            var approval, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        approval = {
                            order_id: this.$cashier.order().id(),
                            payment_amount: this.payment.payment_amount,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.VueStoreFactory.dispatch("payments/CREATE_PAYPAL_PAYMENT_ORDER", this.paypalApproval.bodyFor(approval, function (requestId) { return (__assign(__assign({}, approval), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.failed(error_2));
                        throw error_2;
                    case 4: return [2 /*return*/, {
                            paypal_order_id: response.paypal_order_id,
                            drivescout_order_id: response.order_id,
                        }];
                }
            });
        });
    };
    StudentOrderController.prototype.handlePaypalCardTokenCreated = function (tokenData) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.submitted = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.VueStoreFactory.dispatch("payments/CAPTURE_PAYPAL_PAYMENT_ORDER", {
                                order_id: tokenData.drivescout_order_id,
                                paypal_order_id: tokenData.paypal_order_id,
                            })];
                    case 2:
                        response = _b.sent();
                        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        this.handlePaymentSuccess(response, this.payment);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.failed(error_3));
                        console.error("PayPal payment capture failed:", error_3);
                        this.submitted = false;
                        this.FlashService.setMessage({
                            type: "error",
                            message: ((_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.data) === null || _a === void 0 ? void 0 : _a.message) || "Payment failed. Please try again.",
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return StudentOrderController;
}());
StudentOrderController.$inject = [
    "OrdersModel",
    "FlashService",
    "UsersModel",
    "$stateParams",
    "UserService",
    "CreateOrderService",
    "OrderDetailsService",
    "$location",
    "Stripe3DSService",
    "VueStoreFactory",
    "$scope",
];
exports.default = StudentOrderController;
